import * as React from "react";
import { renderBetButtonsRegular } from "./renderBetButtonsRegular";
import { pickLiveOrPreliveId, prepareEmptyMarket, findFirstAvailableMarket } from "../../../../../../helpers";
export const renderMarketsRegular = (cardProps, buttonsHolderClass, componentPrefix) => {
    let marketsInConfig = cardProps.sport.config.markets;
    let market = prepareMarket(cardProps.markets, marketsInConfig, cardProps.event.isLive);
    let emptyMarket = prepareEmptyMarket(cardProps.event.id, marketsInConfig[0].template, 0);
    return (React.createElement("div", { key: `${componentPrefix}__buttons-holder__${cardProps.event.id}`, className: `rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${componentPrefix}-buttons-holder` }, renderBetButtonsRegular(cardProps, market || emptyMarket, componentPrefix)));
};
const prepareMarket = (markets, marketsConfig, isLive) => {
    let ids = marketsConfig.map(m => pickLiveOrPreliveId(m, isLive));
    return findFirstAvailableMarket(markets, ids);
};
//# sourceMappingURL=renderMarketsRegular.js.map